import { Toast, ToastMessage } from '@agro1desenvolvimento/react-components';
import { FC, useEffect, useRef } from 'react';

const Agro1Toast: Agro1ToastType = () => {
  const toastRef = useRef<Toast>(null);

  useEffect(() => {
    Agro1Toast.show = (message) => {
      toastRef.current?.show(message);
    };
  }, []);

  return <Toast baseZIndex={1300} ref={toastRef} />;
};

Agro1Toast.show = () => {
  throw new Error('Agro1Toast não inicializado.');
};

interface Agro1ToastType extends FC {
  show: (message: ToastMessage | ToastMessage[]) => void;
}

export default Agro1Toast;
